var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$vuetify.breakpoint.mobile,
      expression: "!$vuetify.breakpoint.mobile"
    }],
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.banners, function (banner) {
    return _c('div', {
      key: banner._id,
      staticClass: "swiper-slide"
    }, [banner.isUrl ? _c('div', [_c('a', {
      staticClass: "background background--7",
      attrs: {
        "href": banner.open
      }
    }, [_c('img', {
      attrs: {
        "src": banner.image,
        "alt": ""
      }
    })])]) : _c('div', [_c('router-link', {
      staticClass: "background background--2",
      attrs: {
        "to": banner.to
      }
    }, [_c('img', {
      attrs: {
        "src": banner.image,
        "alt": ""
      }
    })])], 1)]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }